import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from '@/pages/Landing';
import MentionsLegales from '@/pages/MentionsLegales';
import PolitiqueConfidentialite from '@/pages/PolitiqueConfidentialite';
import { GoogleAnalytics } from '@/components/GoogleAnalytics';

function App() {
    return (
        <div className="App">
            <GoogleAnalytics />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
